import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers/index";
import { createLogicMiddleware } from "redux-logic";
import { composeWithDevTools } from "redux-devtools-extension";
import arrLogic from "./logic/logic";

const logicMiddleWare = createLogicMiddleware(arrLogic);

export default function configureStore(initialState) {
	return createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(logicMiddleWare)));
}
